import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { GridRowId } from "@mui/x-data-grid";
import { useDeleteConfig } from "../Orion/OrionQueries";
import { DialogProps } from "./useDialogs";

function DeleteConfigsDialog({
  payload,
  open,
  onClose,
}: DialogProps<readonly GridRowId[]>) {
  const { mutate: deleteConfig } = useDeleteConfig();

  return (
    <Dialog
      open={open}
      onClose={() => onClose()}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        Supprimer les configurations?
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          Vous êtes sur le point de supprimer {payload.length} configurations
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onClose()}>Annuler</Button>
        <Button
          onClick={() => {
            payload.forEach((id) => {
              deleteConfig(id as string);
            });
            onClose();
          }}
          autoFocus
        >
          Supprimer
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default DeleteConfigsDialog;
